import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Drawer,
  Divider,
} from "@material-ui/core";
import {
  Search,
  Filter,
  FilterX,
  Inbox,
  CheckSquare,
  MessageSquare,
  Clock,
  Users,
  User,
  CirclePlus,
  CircleX,
  MessageCircle,
  BadgeCheck,
  ArrowUpDown,
  MessageSquareDot,
  X,
  Tag,
} from "lucide-react";

import CustomToggleSwitch from "../CustomToggleSwitch";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    border: "none !important",
    backgroundColor: theme.mode === "light" ? theme.palette.tabHeaderBackground : "#11141b",
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // backgroundColor: "#eee",
    // backgroundColor: theme.palette.tabHeaderBackground,
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },

    // "&$selected": {
    //   color: "#FFF",
    //   backgroundColor: theme.palette.primary.main,
    // },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
  },

  tabIndicator: {
    height: 6,
    bottom: 0,
    borderRadius: "0 0 8px 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.04)",
    borderRadius: 12,
    border: "none",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },

  serachInputWrapper: {
    flex: 1,
    height: 40,
    background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.04)",
    display: "flex",
    borderRadius: 12,
    padding: 4,
    border: "none",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 12,
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-10px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#fff",
    fontWeight: 700,
    minWidth: 18,
    height: 18,
    padding: "0 5px",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 28,
    width: 28,
    border: "none",
    borderRadius: 0,
    padding: 0,
    marginRight: 4,
    minWidth: 0,
    background: "none",
    "&:hover": {
      background: "none",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  filterDrawerPaper: {
    width: 360,
    [theme.breakpoints.down("xs")]: {
      width: "85vw",
    },
    backgroundColor: theme.mode === "light" ? "#fff" : "#121212",
    backgroundImage: "none",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    overflow: "hidden",
  },
  filterDrawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px",
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText || "#fff",
    flex: "0 0 auto",
  },
  filterDrawerTitle: {
    fontWeight: 600,
    fontSize: 15,
    color: "inherit",
  },
  filterDrawerClose: {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    color: "#fff",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.22)",
      color: "#fff",
    },
  },
  filterDrawerContent: {
    flex: "1 1 auto",
    overflowY: "auto",
    padding: theme.spacing(1, 0.5),
    ...theme.scrollbarStyles,
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
    },
    "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
      borderRadius: "12px !important",
    },
  },
  filterSectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: theme.mode === "light" ? "#5a6a7a" : "#8696a0",
    padding: theme.spacing(1, 1.5, 0.5),
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  // const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);
  const [isHoveredUnreplied, setIsHoveredUnreplied] = useState(false);
  const [unrepliedFilter, setUnrepliedFilter] = useState(false);
  const [showTags, setShowTags] = useState(() => {
    try {
      const v = localStorage.getItem("showTicketTags");
      return v === null ? true : v === "true";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try { localStorage.setItem("showTicketTags", String(showTags)); } catch {}
  }, [showTags]);

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      // setFilter(false);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {

    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    // if (newValue === "pending" || newValue === "group") {
    handleBack();
    // }

    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
    } else setFilter(true);
    setTab("search");
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper elevation={0} square className={classes.ticketsWrapper}>
      <Drawer
        anchor="left"
        open={filter}
        onClose={() => {
          setFilter(false);
          setIsFilterActive(false);
          setTab("open");
        }}
        classes={{ paper: classes.filterDrawerPaper }}
      >
        <div className={classes.filterDrawerHeader}>
          <Typography className={classes.filterDrawerTitle}>
            {i18n.t("ticketsResponsive.filter.title")}
          </Typography>
          <IconButton
            size="small"
            aria-label="close-filter"
            className={classes.filterDrawerClose}
            onClick={() => {
              setFilter(false);
              setIsFilterActive(false);
              setTab("open");
            }}
          >
            <X size={18} />
          </IconButton>
        </div>
        <div className={classes.filterDrawerContent}>
          <Typography className={classes.filterSectionLabel}>
            {i18n.t("ticketsResponsive.filter.queues")}
          </Typography>
          <div style={{ padding: 10 }}>
            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => setSelectedQueueIds(values)}
            />
          </div>
          <Typography className={classes.filterSectionLabel}>
            {i18n.t("ticketsResponsive.filter.tags")}
          </Typography>
          <TagsFilter onFiltered={handleSelectedTags} />
          <Typography className={classes.filterSectionLabel}>
            {i18n.t("ticketsResponsive.filter.connections")}
          </Typography>
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <Typography className={classes.filterSectionLabel}>
            {i18n.t("ticketsResponsive.filter.status")}
          </Typography>
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <Typography className={classes.filterSectionLabel}>
                {i18n.t("ticketsResponsive.filter.users")}
              </Typography>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </div>
      </Drawer>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <div className={classes.serachInputWrapper}>
        <Search className={classes.searchIcon} size={20} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        <Tooltip placement="top" title={i18n.t("ticketsResponsive.search.searchInMessagesTooltip")}>
          <div style={{ display: "inline-flex", alignItems: "center", marginRight: 8 }}>
            <CustomToggleSwitch
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
      </div>

      {/* <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          textColor="primary"
          aria-label="icon label tabs example"
          classes={{ indicator: classes.tabIndicator }}
        >
          <Tab
            value={"open"}
            icon={<Inbox size={18} />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<CheckSquare size={18} />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"search"}
            icon={<Search size={18} />}
            label={i18n.t("tickets.tabs.search.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper> */}
      <Snackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={i18n.t("tickets.inbox.closedAllTickets")}
        ContentProps={{ className: classes.snackbar }}
        action={
          <>
            <Button className={classes.yesButton} size="small" onClick={CloseAllTicket}>
              {i18n.t("tickets.inbox.yes")}
            </Button>
            <Button className={classes.noButton} size="small" onClick={handleSnackbarClose}>
              {i18n.t("tickets.inbox.no")}
            </Button>
          </>
        }
      />
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "4px 0", paddingLeft: 10 }}>
          {(user.profile === "admin" || user.allUserChat === "enabled") && (
            <Tooltip title={i18n.t("ticketsList.buttons.showAll")}>
              <span
                style={{ cursor: "pointer", display: "inline-flex", color: showAllTickets ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
                onClick={() => setShowAllTickets((prev) => !prev)}
              >
                {showAllTickets ? (
                  <Users size={18} />
                ) : (
                  <User size={18} />
                )}
              </span>
            </Tooltip>
          )}

          <Tooltip title={i18n.t("tickets.inbox.newTicket")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", color: "#555" }}
              onClick={() => setNewTicketModalOpen(true)}
            >
              <CirclePlus size={18} />
            </span>
          </Tooltip>

          {user.profile === "admin" && (
            <Tooltip title={i18n.t("tickets.inbox.closedAll")}>
              <span
                style={{ cursor: "pointer", display: "inline-flex", color: "#555" }}
                onClick={handleSnackbarOpen}
              >
                <CircleX size={18} />
              </span>
            </Tooltip>
          )}

          <Tooltip title={i18n.t("tickets.inbox.open")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", color: tab === "open" ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
              onClick={() => handleChangeTab(null, "open")}
            >
              <MessageCircle size={18} />
            </span>
          </Tooltip>

          <Tooltip title={i18n.t("tickets.inbox.resolverd")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", color: tab === "closed" ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
              onClick={() => handleChangeTab(null, "closed")}
            >
              <BadgeCheck size={18} />
            </span>
          </Tooltip>

          {tab !== "closed" && tab !== "search" && (
            <Tooltip title={!sortTickets ? i18n.t("ticketsResponsive.sort.ascending") : i18n.t("ticketsResponsive.sort.descending")}>
              <span
                style={{ cursor: "pointer", display: "inline-flex", color: sortTickets ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
                onClick={() => setSortTickets((prev) => !prev)}
              >
                <ArrowUpDown size={18} style={{ transform: sortTickets ? "rotate(180deg)" : "none", transition: "transform 0.2s" }} />
              </span>
            </Tooltip>
          )}

          <Tooltip title={i18n.t("ticketsResponsive.filter.unreplied")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", color: unrepliedFilter ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
              onClick={() => setUnrepliedFilter((prev) => !prev)}
            >
              <MessageSquareDot size={18} />
            </span>
          </Tooltip>

          <Tooltip title={showTags ? i18n.t("ticketsResponsive.filter.hideTags") : i18n.t("ticketsResponsive.filter.showTags")}>
            <span
              style={{ cursor: "pointer", display: "inline-flex", color: showTags ? theme.palette.primary.main : "#555", transition: "color 0.2s" }}
              onClick={() => setShowTags((prev) => !prev)}
            >
              <Tag size={18} />
            </span>
          </Tooltip>
        </div>
        <div>
          <Tooltip title={i18n.t("ticketsResponsive.filter.title")}>
            <IconButton
              size="small"
              aria-label="filter"
              onClick={() => {
                setIsFilterActive((prevState) => !prevState);
                handleFilter();
              }}
              style={{
                color: isFilterActive ? theme.palette.primary.main : (theme.mode === "light" ? "#555" : "#e9edef"),
              }}
            >
              {isFilterActive ? (
                <Filter size={18} />
              ) : (
                <FilterX size={18} />
              )}
            </IconButton>
          </Tooltip>
        </div>
      </Paper>
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >
                    <MessageSquare size={18} />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 10,
                      fontWeight: 600,
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <Clock size={18} />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 10,
                      fontWeight: 600,
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item>
                    <Badge
                      overlap="rectangular"
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <Users size={18} />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 10,
                        fontWeight: 600,
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            unreplied={unrepliedFilter}
            showTags={showTags}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            unreplied={unrepliedFilter}
            showTags={showTags}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              unreplied={unrepliedFilter}
              showTags={showTags}
            />
          )}
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
          showTags={showTags}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
              showTags={showTags}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
            showTags={showTags}
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
